// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iMho","top":"styles_top__Ud5nI","left":"styles_left__8EvC4","description":"styles_description__2Tniz"};